import { render, staticRenderFns } from "./personalization.vue?vue&type=template&id=6ecde8e6&scoped=true"
import script from "./personalization.vue?vue&type=script&lang=js"
export * from "./personalization.vue?vue&type=script&lang=js"
import style0 from "./personalization.vue?vue&type=style&index=0&id=6ecde8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecde8e6",
  null
  
)

export default component.exports